import { render } from "./AirQuality.vue?vue&type=template&id=d83a621c&scoped=true"
import script from "./AirQuality.vue?vue&type=script&lang=js"
export * from "./AirQuality.vue?vue&type=script&lang=js"

import "./AirQuality.vue?vue&type=style&index=0&id=d83a621c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83a621c"]])

export default __exports__